import { render } from "./DropdownPropertyControl.vue?vue&type=template&id=0484855c&scoped=true"
import script from "./DropdownPropertyControl.vue?vue&type=script&lang=js"
export * from "./DropdownPropertyControl.vue?vue&type=script&lang=js"

import "./DropdownPropertyControl.vue?vue&type=style&index=0&id=0484855c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0484855c"]])

export default __exports__